import Vue from 'vue'
import Router from 'vue-router'
import index from '../pages/index/index'


Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{title:"首页"}
    },
    {
      path: '/companyDeatil',
      name: 'companyDeatil',
      component: () => import('../pages/companyDeatil/index.vue'),
      meta:{title:"证书详情"}
    },
    {
      path: '/pcSearch',
      name: 'pcSearch',
      component: () => import('../pages/pcSearch/index.vue'),
      meta:{title:"证书搜索"}
    },
    {
      path: '/PcCompanyDeatil',
      name: 'PcCompanyDeatil',
      component: () => import('../pages/PcCompanyDeatil/index.vue'),
      meta:{title:"证书详情"}
    },
   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js